import { handleActions, combineActions } from "redux-actions";

import { getUsersAsyncAction, createUserAsyncAction } from "./userActions";

const initialState = {
	list: {
		items: [],
		meta: {
			currentPage: 0,
			totalPages: 0,
		},
	},

	detail: {},

	fetch: {
		loading: false,
		error: "",
	},

	action: {
		loading: false,
		success: false,
		error: "",
	},
};

export const userReducer = handleActions(
	new Map([
		[
			[combineActions(createUserAsyncAction.request)],
			(state) => ({
				...state,
				action: {
					...initialState.action,
					loading: true,
				},
			}),
		],
		[
			combineActions(createUserAsyncAction.success),
			(state, { payload }) => ({
				...state,
				action: {
					...initialState.action,
					success: payload,
				},
			}),
		],
		[
			getUsersAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: payload,
			}),
		],
	]),
	initialState
);
